import notHandledHere from './notHandledHere';
import { constants } from 'lib_ui-services';
import { UserError } from '@sstdev/lib_logging';

export default {
    verb: 'willCancel',
    description: 'Confirm with the user before canceling if the form has unsaved changes.',
    excludedNamespaceRelations: notHandledHere,
    //this is the actual logic:
    logic: willCancel
};

async function willCancel({ data, dispatch }) {
    // Only show confirmation if the cancel originated from a FormButton
    // that passed isDirty status. Non-FormButton cancels will fall through
    // and ActiveRecord's existing confirmation will handle them.
    if (data.isDirty === true) {
        const confirmed = await new Promise(resolve => {
            dispatch(
                {
                    jumpQueue: true,
                    message: 'Are you sure you want to cancel without saving?',
                    okButtonText: 'YES',
                    cancelButtonText: 'NO',
                    variant: constants.VARIANT.Warning,
                    okAction: () => resolve(true),
                    cancelAction: () => resolve(false)
                },
                { verb: 'confirm', namespace: 'application', relation: 'user' }
            );
        });
        if (!confirmed) {
            throw new UserError('Cancel was not confirmed by user.');
        }
    }
    // If isDirty was explicitly provided (from FormButton), mark ignoreChanges
    // so ActiveRecord skips its redundant confirmation dialog
    if (data.isDirty != null) {
        return { ...data, ignoreChanges: true };
    }
    return data;
}
